import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { ScrollView, tokens } from '@fhs/ui';
import { useFeatureNavigation } from '@fhs-legacy/frontend/src/hooks/use-feature-navigation';

import { type NavigationEntry, flattenNavigationEntries, policyLinks } from './more-navigation';
import { MoreLinkCard } from './shared';

const BOTTOM_NAV_CLEARANCE = 142;

export function OtherTermsScreen() {
  const { featureAboutMenuEntriesMobile } = useFeatureNavigation();
  const cmsLinks = useMemo(
    () =>
      flattenNavigationEntries(
        (featureAboutMenuEntriesMobile?.pages ?? []) as readonly NavigationEntry[]
      ),
    [featureAboutMenuEntriesMobile]
  );

  return (
    <View style={styles.screen}>
      <ScrollView contentContainerStyle={styles.content}>
        <MoreLinkCard links={policyLinks(cmsLinks)} />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1, backgroundColor: tokens.colors.$white },
  content: {
    alignSelf: 'center',
    maxWidth: 600,
    paddingBottom: BOTTOM_NAV_CLEARANCE,
    paddingHorizontal: 16,
    paddingTop: 24,
    width: '100%',
  },
});
